<div class="row mt-5" *ngIf="commonDentalPlanSavings" role="region" aria-label="Common Dental Plan Savings">
  <div class="col-12">
    <app-card-container>
      <div class="row">
        <div class="col-12">
          <div class="header-text" id="cdps-heading">Common Dental Plan Savings</div>
        </div>
      </div>
      <div class="table-scroll-wrapper">
        <div class="table-content">
          <div class="row mt-5 mb-3" role="row">
            <div class="table-title" role="columnheader" [ngClass]="getCdpsColumnClass()" *ngIf="getShowAdaCode()">ADA Code</div>
            <div class="table-title" role="columnheader" [ngClass]="getCdpsColumnClass()">Procedure Description</div>
            <div class="table-title" role="columnheader" [ngClass]="getCdpsColumnClass()">{{ getMemberColumnLabel() }}</div>
            <div class="col-12 border-gray mt-2"></div>
          </div>
          <div *ngFor="let group of commonDentalPlanSavings?.groups" role="rowgroup">
            <ng-container *ngIf="group.itemName !== FOOTER_GROUP">
              <ng-container *ngIf="getSplit(group) as split">
                <div class="row" [class.mt-2]="!hasAnyVisibleItems()">
                  <div [ngClass]="headerCellClasses(!!split.categoryValue, false)">{{ group.itemName }}</div>
                  <div *ngIf="split.categoryValue as categorySavings" [ngClass]="headerCellClasses(true, true)">{{ categorySavings }}</div>
                  <div class="col-12 border-gray" *ngIf="!hasAnyVisibleItems()"></div>
                </div>
                <div class="row mt-2" role="row" *ngFor="let item of split.visible">
                  <div class="mb-3" role="cell" data-label="ADA Code" [ngClass]="getCdpsColumnClass()" *ngIf="getShowAdaCode()">
                    <span class="cell-value">{{ item.adaCode }}</span>
                  </div>
                  <div class="mb-3" role="cell" data-label="Procedure" [ngClass]="getCdpsColumnClass()">
                    <span class="cell-value">{{ item.description }}</span>
                  </div>
                  <div class="mb-3" role="cell" [attr.data-label]="getMemberColumnLabel()" [ngClass]="getCdpsColumnClass()">
                    <span class="cell-value">{{ item.memberPays }}</span>
                  </div>
                  <div class="col-12 border-gray"></div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row mt-5 mb-3">
        <div class="col-12 col-lg-12 mb-3 sub-text2" *ngIf="footer !== DEFAULT_FOOTER" role="note">*Member savings may vary by location. {{ getXrayExamStatement() }} Any services not listed are available at a minimum of {{ footer }} off the office's Retail Fee(s).</div>
        <div class="col-12 col-lg-12 mb-3 sub-text">You are responsible for payment of the dentist's normal fees for any of the following limited services:</div>
        <div class="col-12 col-lg-12 mb-3 sub-text2">
          Replacement of partial dentures is limited to one per arch every two years. <br />
          Replacement of full upper and lower dentures are limited to one per arch every two years. <br />
          Replacement of fixed prosthetics such as crowns, bridges, inlays, and onlays is limited to once every year.
        </div>
      </div>
    </app-card-container>
  </div>
</div>
